import moment from "moment/moment";
import { useEffect, useState } from "react";
import { Modal, Row } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { useLazyBookingDetailsQuery } from "../../redux/api/api";
import TopHeader from "../Dashoboard/TopHeader";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch } from "react-redux";
import { saveLoader } from "../../redux/slice/loaderNoti";

const BookedRoomsView = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [details, setDetails] = useState({});
  const [modal, setModal] = useState(false);
  const [modalData, setModalData] = useState("");
  const [modalType, setModalType] = useState("");

  // RTK QUERY
  const [bookingDetailsApi] = useLazyBookingDetailsQuery();

  const getBookingDetails = () => {
    dispatch(saveLoader(true));
    bookingDetailsApi(location?.state?.data?.id)
      .unwrap()
      .then((res) => {
        dispatch(saveLoader(false));
        setDetails(res);
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        console.log("err", err);
      });
  };

  useEffect(() => {
    if (location?.state?.data?.id) {
      getBookingDetails();
    }
  }, []);

  const popUpHandler = (url, type) => {
    setModalType(type);
    setModal(true);
    setModalData(url);
  };

  return (
    <div className="dashRightView home_section">
      <TopHeader type={"booked-rooms-view"} />
      <div className="block block-rounded ">
        <div className="block-content mt-4">
          <div className="user-detail-table">
            <table className="tabledetails table-borderless user-det w-100 mb-5">
              <thead>
                <th colspan="3" className="h8 mb-0 font-weight-light p-3">
                  Profile Details
                </th>
              </thead>
              <tbody>
                <tr>
                  <td style={{ width: "40%" }}>User ID</td>
                  <td>:</td>
                  <td>
                    <button
                      className="link-btn"
                      onClick={() => {
                        if (details?.booking?.user?.user_id) {
                          navigate("/user", {
                            state: { data: details?.booking?.user },
                          });
                        }
                      }}
                    >
                      {details?.booking?.user?.user_id
                        ? details?.booking?.user?.user_id
                        : "-"}
                    </button>
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "40%" }}>Owner ID</td>
                  <td>:</td>
                  <td>
                    {" "}
                    <button
                      className="link-btn"
                      onClick={() => {
                        if (details?.booking?.owner.owner_id) {
                          navigate("/property-owner-view", {
                            state: {
                              type: "edit",
                              data: details?.booking?.owner,
                            },
                          });
                        }
                      }}
                    >
                      {details?.booking?.owner.owner_id
                        ? details?.booking?.owner.owner_id
                        : "-"}
                    </button>
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "40%" }}>Receptionist ID</td>
                  <td>:</td>
                  <td>
                    {" "}
                    <button
                      className="link-btn"
                      onClick={() => {
                        if (
                          details?.booking?.property?.receptionist
                            ?.receptionist_id
                        ) {
                          navigate("/receptionist-view", {
                            state: {
                              type: "view",
                              data: details?.booking?.property?.receptionist,
                            },
                          });
                        }
                      }}
                    >
                      {details?.booking?.property?.receptionist?.receptionist_id
                        ? details?.booking?.property?.receptionist
                            ?.receptionist_id
                        : "-"}
                    </button>
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "40%" }}>Property ID</td>
                  <td>:</td>
                  <td>
                    {" "}
                    <button
                      className="link-btn"
                      onClick={() => {
                        if (details?.booking?.property?.property_id) {
                          navigate("/property-view", {
                            state: {
                              type: "edit",
                              data: details?.booking?.property,
                            },
                          });
                        }
                      }}
                    >
                      {details?.booking?.property?.property_id
                        ? details?.booking?.property?.property_id
                        : "-"}
                    </button>
                  </td>
                </tr>
                <tr class="bg-purple p-2 rounded my-2">
                  <td colspan="3" class="h8_2 mb-0 font-weight-light p-3">
                    Booking Details
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "40%" }}>Property Name</td>
                  <td>:</td>
                  <td>{details?.booking?.property?.name}</td>
                </tr>
                <tr>
                  <td style={{ width: "40%" }}>Property Image</td>
                  <td>:</td>
                  <td>
                    <img
                      src={details?.booking?.property?.image}
                      alt="property-img"
                      class="img-fluid"
                      style={{ width: "30%" }}
                    />
                  </td>
                </tr>

                <tr>
                  <td style={{ width: "40%" }}>Service Type</td>
                  <td>:</td>
                  <td>{details?.booking?.service_type}</td>
                </tr>

                <tr>
                  <td style={{ width: "40%" }}>Booking ID</td>
                  <td>:</td>
                  <td>{details?.booking?.booking_id}</td>
                </tr>
                <tr>
                  <td style={{ width: "40%" }}>Booking By</td>
                  <td>:</td>
                  <td>{details?.booking?.guest_name}</td>
                </tr>
                <tr>
                  <td style={{ width: "40%" }}>From Date</td>
                  <td>:</td>
                  <td>
                    {details?.booking?.from_date
                      ? moment(details?.booking?.from_date).format(
                          "DD-MM-YYYY hh:mm a"
                        )
                      : ""}
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "40%" }}>To Date</td>
                  <td>:</td>
                  <td>
                    {details?.booking?.to_date
                      ? moment(details?.booking?.to_date).format(
                          "DD-MM-YYYY hh:mm a"
                        )
                      : ""}
                  </td>
                </tr>
                {details?.booking_detail?.id &&
                (details?.booking?.service_type == "day_outing" ||
                  details?.booking?.service_type == "just_walking") ? (
                  <tr>
                    <td style={{ width: "40%" }}>No.of.Adults</td>
                    <td>:</td>
                    <td>{details?.booking_detail?.no_of_adults}</td>
                  </tr>
                ) : null}

                {details?.booking_detail?.id &&
                (details?.booking?.service_type == "day_outing" ||
                  details?.booking?.service_type == "just_walking") ? (
                  <tr>
                    <td style={{ width: "40%" }}>No.of.Childrens</td>
                    <td>:</td>
                    <td>{details?.booking_detail?.no_of_childrens}</td>
                  </tr>
                ) : null}

                <tr>
                  <td style={{ width: "40%" }}>Check-In Date</td>
                  <td>:</td>
                  <td>{details?.booking?.check_in}</td>
                </tr>
                <tr>
                  <td style={{ width: "40%" }}>Check-Out Date</td>
                  <td>:</td>
                  <td>{details?.booking?.check_out}</td>
                </tr>

                {details?.booking?.service_type != "day_outing" ||
                details?.booking?.service_type != "just_walking" ? (
                  <tr>
                    <td style={{ width: "40%" }}>No.of.rooms</td>
                    <td>:</td>
                    <td>{details?.booking?.no_of_rooms}</td>
                  </tr>
                ) : null}

                {details?.booking_detail?.id &&
                (details?.booking?.service_type !== "day_outing" ||
                  details?.booking?.service_type !== "just_walking") ? (
                  <tr>
                    <td style={{ width: "40%" }}>Room Tariff</td>
                    <td>:</td>
                    <td>{details?.booking_detail?.room_tariff}</td>
                  </tr>
                ) : null}

                {details?.booking_detail?.id &&
                details?.booking_detail?.extra_person_charge ? (
                  <tr>
                    <td style={{ width: "40%" }}>Extra Person Price</td>
                    <td>:</td>
                    <td>{details?.booking_detail?.extra_person_charge}</td>
                  </tr>
                ) : null}

                {details?.booking_detail?.id &&
                details?.booking_detail?.extra_person_charge ? (
                  <tr>
                    <td style={{ width: "40%" }}>Extra Person Charge</td>
                    <td>:</td>
                    <td>
                      {details?.booking_detail?.no_of_extra_persons +
                        " x " +
                        details?.booking_detail?.extra_person_charge +
                        " = " +
                        details?.booking_detail?.no_of_extra_persons *
                          details?.booking_detail?.extra_person_charge}
                    </td>
                  </tr>
                ) : null}
                {details?.booking_detail?.id &&
                details?.booking_detail?.tips_amount ? (
                  <tr>
                    <td style={{ width: "40%" }}>Tips amount</td>
                    <td>:</td>
                    <td>{details?.booking_detail?.tips_amount}</td>
                  </tr>
                ) : null}

                <tr>
                  <td style={{ width: "40%" }}>Actual Price</td>
                  <td>:</td>
                  <td>₹{details?.booking?.total_amount}</td>
                </tr>

                <tr>
                  <td style={{ width: "40%" }}>Total Payable Amount</td>
                  <td>:</td>
                  <td>₹{details?.booking?.total_payable_amount}</td>
                </tr>

                <tr>
                  <td style={{ width: "40%" }}>Amount Paid at (User App)</td>
                  <td>:</td>
                  <td>₹{details?.booking?.amount_paid}</td>
                </tr>

                <tr>
                  <td style={{ width: "40%" }}>Balance Payable Amount</td>
                  <td>:</td>
                  <td>₹{details?.booking?.balance_amount}</td>
                </tr>

                <tr>
                  <td style={{ width: "40%" }}>Status</td>
                  <td>:</td>
                  <td>
                    {details?.booking?.booking_status == 1
                      ? "Booked"
                      : "Cancel"}
                  </td>
                </tr>

                <tr class="bg-purple p-2 rounded my-2">
                  <td colspan="3" class="h8_2 mb-0 font-weight-light p-3">
                    Additional Details
                  </td>
                </tr>

                {details?.booking_detail?.id ? (
                  <tr>
                    <td style={{ width: "40%" }}>Extra Person Charge</td>
                    <td>:</td>
                    <td>{details?.booking_detail?.extra_person_charge}</td>
                  </tr>
                ) : null}

                {details?.booking_detail?.id ? (
                  <tr>
                    <td style={{ width: "40%" }}>Extra Person Count</td>
                    <td>:</td>
                    <td>{details?.booking_detail?.no_of_extra_persons}</td>
                  </tr>
                ) : null}

                {details?.booking_detail?.id ? (
                  <tr>
                    <td style={{ width: "40%" }}>Extra Person Total Amount</td>
                    <td>:</td>
                    <td>
                      {details?.booking_detail?.extra_person_charge >= 0 &&
                      details?.booking_detail?.no_of_extra_persons >= 0
                        ? details?.booking_detail?.extra_person_charge *
                          details?.booking_detail?.no_of_extra_persons
                        : details?.booking_detail?.no_of_extra_persons
                        ? details?.booking_detail?.no_of_extra_persons
                        : details?.booking_detail?.extra_person_charge}
                    </td>
                  </tr>
                ) : null}

                {details?.booking_detail?.id ? (
                  <tr>
                    <td style={{ width: "40%" }}>Weekend Percentage</td>
                    <td>:</td>
                    <td>{details?.booking_detail?.weekend_percentage}</td>
                  </tr>
                ) : null}

                {details?.booking?.proofs?.map((item, ind) => {
                  return (
                    <tr key={ind}>
                      <td style={{ width: "40%" }}>Proof</td>
                      <td>:</td>
                      <td>
                        {item?.document?.match(/\.(pdf)$/) ? (
                          <p>
                            <button
                              className="cust-btn"
                              onClick={() =>
                                popUpHandler(item?.document, "pdf")
                              }
                            >
                              PDF Document
                            </button>
                          </p>
                        ) : (
                          <p>
                            <button
                              className="cust-btn"
                              onClick={() =>
                                popUpHandler(item?.document, "image")
                              }
                            >
                              Image Document
                            </button>
                          </p>
                        )}
                      </td>
                    </tr>
                  );
                })}

                <tr class="bg-purple p-2 rounded my-2">
                  <td colspan="3" class="h8_2 mb-0 font-weight-light p-3">
                    Coupon Details
                  </td>
                </tr>
                {details?.booking?.coupon_info != null ? (
                  <tr>
                    <td style={{ width: "40%" }}>Exciting Offers</td>
                    <td>:</td>
                    <td>
                      {details?.booking?.coupon_info["coupon_code"]} -{" "}
                      {details?.booking?.coupon_info["coupon_amount"]}
                    </td>
                  </tr>
                ) : null}

                {details?.booking_detail?.id ? (
                  <tr>
                    <td style={{ width: "40%" }}>Discount</td>
                    <td>:</td>
                    <td>{details?.booking_detail?.discount}</td>
                  </tr>
                ) : null}

                {details?.booking_detail?.id ? (
                  <tr>
                    <td style={{ width: "40%" }}>Wallet Amount</td>
                    <td>:</td>
                    <td>{details?.booking_detail?.wallet_amount}</td>
                  </tr>
                ) : null}

                <tr class="bg-purple p-2 rounded my-2">
                  <td colspan="3" class="h8_2 mb-0 font-weight-light p-3">
                    Transaction Details
                  </td>
                </tr>

                {details?.transaction?.id ? (
                  <tr>
                    <td style={{ width: "40%" }}>Type</td>
                    <td>:</td>
                    <td>{details?.transaction?.type}</td>
                  </tr>
                ) : null}

                <tr>
                  <td style={{ width: "40%" }}>Payment Mode</td>
                  <td>:</td>
                  <td>
                    {details?.booking?.payment_mode == 1
                      ? "Partially paid"
                      : "Fully Paid"}
                  </td>
                </tr>

                {details?.transaction?.id ? (
                  <tr>
                    <td style={{ width: "40%" }}>Transaction Amount</td>
                    <td>:</td>
                    <td>{details?.transaction?.transaction_amount}</td>
                  </tr>
                ) : null}

                {details?.transaction?.id ? (
                  <tr>
                    <td style={{ width: "40%" }}>Payment method</td>
                    <td>:</td>
                    <td>{details?.transaction?.payment_info?.method}</td>
                  </tr>
                ) : null}

                {details?.transaction?.id ? (
                  <tr>
                    <td style={{ width: "40%" }}>Payment status</td>
                    <td>:</td>
                    <td>{details?.transaction?.payment_info?.status}</td>
                  </tr>
                ) : null}

                {details?.transaction?.id ? (
                  <tr>
                    <td style={{ width: "40%" }}>Date Time</td>
                    <td>:</td>
                    <td>
                      {details?.transaction?.created_at
                        ? moment(details?.transaction?.created_at).format(
                            "DD-MM-YYYY hh:mm a"
                          )
                        : ""}
                    </td>
                  </tr>
                ) : null}

                {details?.transaction?.id ? (
                  <tr>
                    <td style={{ width: "40%" }}>Payment order id</td>
                    <td>:</td>
                    <td>{details?.transaction?.payment_info?.order_id}</td>
                  </tr>
                ) : null}

                {details?.booking?.payment_mode == 1 ? (
                  <tr>
                    <td style={{ width: "40%" }}>Balance Amount</td>
                    <td>:</td>
                    <td>{details?.booking?.balance_amount}</td>
                  </tr>
                ) : null}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <Modal
        show={modal}
        onHide={() => {
          setModal(false);
        }}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
      >
        <div>
          <Row>
            <div className="d-flex ac-jb">
              <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20">
                Document
              </label>
              <button className="cust-btn" onClick={() => setModal(false)}>
                <CloseIcon />
              </button>
            </div>
          </Row>
          <Row>
            {modalType == "pdf" ? (
              <div>
                <iframe
                  src={modalData ? modalData : null}
                  style={{ height: "500px", width: "100%" }}
                ></iframe>
              </div>
            ) : (
              <div>
                <img src={modalData} alt={modalData} />
              </div>
            )}
          </Row>
        </div>
      </Modal>
    </div>
  );
};

export default BookedRoomsView;
